(function () {
    'use strict';
    $(document).ready(function () {
        const $header = $('header');
        const $menuOverlay = $('.menu-overlay');
        let lastWindowWidth = $(window).width();

        // Menu toggle
        $(".menu-toggle").on('click', function () {
            $menuOverlay.fadeToggle();
            $menuOverlay.toggleClass('open');
            $(this).toggleClass("open");
            $header.toggleClass('open');
            closeSubmenus();
        });

	    clickedOutside('.menu-overlay', closeMenu, ['.menu-toggle']);

	    $(window).resize(function(){
	        if($(window).width() !== lastWindowWidth){
	            closeMenu();
	            lastWindowWidth = $(window).width();
	        }
	    });

        $('ul.header-main-menu li.menu-item-has-children > a').on('click', function (e) {
            e.preventDefault();
            const $this = $(this);
            const submenuLevel = $this.data('depth');
            if ($this.hasClass('active')) {
                $this.siblings('.submenu').stop().slideUp();
                $this.parent().removeClass('open');
                $this.removeClass('active');
            } else {
                closeSubmenus(submenuLevel);
                $this.siblings('.submenu').stop().slideToggle();
                $this.parent().toggleClass('open');
                $this.toggleClass('active');
            }
        });

        function closeMenu() {
            $('.header-right nav.open').fadeOut(function () {
                $(this).css('display', '');
                $(this).removeClass('open');
            });
            $header.removeClass('open');
            $('.menu-toggle').removeClass('open');
	        if (window.matchMedia("(max-width: 767px)").matches) {
		        $menuOverlay.fadeOut();
		        $menuOverlay.removeClass('open');
	        }
            closeSubmenus();
        }

        function closeSubmenus(dataLevel = 1) {
            $('div[data-level="' + dataLevel + '"] li.menu-item-has-children > a.active, ul[data-level="' + dataLevel + '"] li.menu-item-has-children > a.active').each(function () {
                $(this).siblings('.submenu').stop().slideToggle(function () {
                    $(this).css('display', '')
                });
                $(this).removeClass('active');
                $(this).parent().removeClass('open');
            });
        }

    });
}(jQuery));